import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Scorecard, ScorecardQuery } from '@fgb/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ScorecardDescriptionComponent } from '../../scorecard-description/scorecard-description.component';
import { Router } from '@angular/router';
@Component({
  selector: 'fgbcl-scorecard-locked',
  templateUrl: './scorecard-locked.component.html',
  styleUrls: ['./scorecard-locked.component.scss'],
})
export class ScorecardLockedComponent implements OnInit {
  @Input() scorecard: Scorecard;
  parentScorecard: Scorecard;
  isOpenModal: boolean = true;
  preventMultipleClick: boolean = false;
  isScorecardHasChild: boolean = false;
  @Input() isSponsorInBody: boolean = false;
  @Input() disabled: boolean;
  constructor(
    private offcanvasService: NgbOffcanvas,
    private scorecardQuery: ScorecardQuery,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.parentScorecard = this.scorecardQuery.getEntity(this.scorecard?.ParentId) as Scorecard;
    this.isScorecardHasChild = this.scorecardQuery.hasLinkedScorecards(this.scorecard?.ScorecardId);
    this.onWindowResize(window.innerWidth);
  }

  @HostListener('window:resize', ['$event.target.screen.width'])
  onWindowResize(event: number) {
    if (event > 576) {
      this.isOpenModal = true;
    } else {
      this.isOpenModal = false;
    }
  }

  openScorecardDescription() {
    if (!this.disabled) {
      this.isOpenModal ? this.openModal() : this.redirectComponent();
    }
  }

  openModal() {
    const offcanvasRef = this.offcanvasService.open(ScorecardDescriptionComponent, {
      position: 'bottom',
      panelClass: 'scorecard-offcanvas-content',
    });
    offcanvasRef.componentInstance.scorecardId = this.scorecard.ScorecardId;
    offcanvasRef.componentInstance.isSponsorInBody = this.isSponsorInBody;
  }

  redirectComponent() {
    let params = this.isSponsorInBody ? { isSponsorInBody: this.isSponsorInBody } : {};
    this.router.navigate(['/scorecard-description', this.scorecard.ScorecardId, params]);
  }
}
